import React from 'react';
import './Header.scss';

function Header ({close}){
	return (
		<div id="header">
			<button
    			onClick={close}
			>NEW PLAY <i className="fas fa-arrow-right"></i></button>
		</div>
    );
}

export default Header;
